import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-breadcrumb-item',
	templateUrl:'./WaBreadcrumbItemPage.html',
	styles: [],
	styleUrls:['./WaBreadcrumbItemPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaBreadcrumbItemPage
{
	mdContent_281 = `\`\`\`java
import com.jwebmp.webawesome.components.breadcrumb.WaBreadcrumbItem;
\`\`\``;
}
